import { P as m, f as P, g as M, m as q, o as S, p as T, s as w } from "./chunks/pageMarks-B3ErYAff.js";
let l = 0;
const o = /* @__PURE__ */ new Set();
function c(s) {
  return o.add(s), () => o.delete(s);
}
class d {
  /** The server said marks changed, or the connection came (back) up. */
  changed() {
    for (const e of [...o]) e();
  }
  pending = /* @__PURE__ */ new Map();
  /** `send` returns false when the message could not go out. */
  request(e, r, t) {
    const n = `marks-${Date.now().toString(36)}-${(l++).toString(36)}`;
    return new Promise((i) => {
      const a = setTimeout(() => this.settle(n, null), t);
      this.pending.set(n, { resolve: i, timer: a }), e({ type: "pageMarksQuery", requestId: n, ...r }) || this.settle(n, null);
    });
  }
  receive(e) {
    this.settle(e.requestId, { marks: e.marks, status: e.status, ...e.coverage ? { coverage: e.coverage } : {} });
  }
  /** Every open query answers null (disconnect, destroy). */
  cancelAll() {
    for (const e of [...this.pending.keys()]) this.settle(e, null);
  }
  settle(e, r) {
    const t = this.pending.get(e);
    t && (this.pending.delete(e), clearTimeout(t.timer), t.resolve(r));
  }
}
let u = 0;
const g = /* @__PURE__ */ new Set();
function h(s) {
  return g.add(s), () => g.delete(s);
}
class p {
  /** The server said links changed, or the connection came (back) up. */
  changed() {
    for (const e of [...g]) e();
  }
  pending = /* @__PURE__ */ new Map();
  /** `send` returns false when the message could not go out. */
  request(e, r, t) {
    const n = `links-${Date.now().toString(36)}-${(u++).toString(36)}`;
    return new Promise((i) => {
      const a = setTimeout(() => this.settle(n, null), t);
      this.pending.set(n, { resolve: i, timer: a }), e({ type: "pageLinksQuery", requestId: n, ...r }) || this.settle(n, null);
    });
  }
  receive(e) {
    this.settle(e.requestId, { outgoing: e.outgoing, incoming: e.incoming, status: e.status });
  }
  /** Every open query answers null (disconnect, destroy). */
  cancelAll() {
    for (const e of [...this.pending.keys()]) this.settle(e, null);
  }
  settle(e, r) {
    const t = this.pending.get(e);
    t && (this.pending.delete(e), clearTimeout(t.timer), t.resolve(r));
  }
}
export {
  m as PageMarksChangeFeed,
  p as TeamPageLinksRequests,
  d as TeamPageMarksRequests,
  P as filterPageMarks,
  M as getPageMarksSource,
  q as mergePageMarks,
  S as onPageMarksSourceChange,
  h as onTeamPageLinksChanged,
  c as onTeamPageMarksChanged,
  T as pageMarkRecordsFromTeamIndex,
  w as setPageMarksSource
};
//# sourceMappingURL=pages.js.map
